// REACT IMPORT: Core React library for functional component
import React from "react"
import { Link } from "react-router-dom"

export const TermsAndConditions = () => {
  return (
    <div className="mx-auto max-w-4xl px-3 py-4 text-white sm:px-4 sm:py-0">
      <div className="rounded-xl bg-white p-4 text-left text-gray-800 shadow-lg sm:rounded-lg sm:p-6 md:p-10">
        <header className="mb-4 text-center sm:mb-8">
          <h1 className="text-2xl font-bold leading-snug text-brand sm:text-3xl md:text-4xl">Terms of Service</h1>
          <p className="mt-2 text-sm font-semibold text-gray-700 sm:mt-3 sm:text-base">
            Effective Date: February 1, 2026
          </p>
        </header>

        <div className="space-y-4 text-sm leading-relaxed sm:space-y-6 sm:text-base md:text-lg">
          <p>
            This website is owned and operated by Sweetest Interactive Entertainment LLC DBA Sweetest Interactive.
            ("Company," "we," "us," or "our"). By accessing or using our website, web application,
            and related services (collectively, the "Service"), you agree to be bound by these
            Terms of Service.
          </p>

          <section>
            <h2 className="mb-2 text-base font-semibold text-brand sm:mb-3 sm:text-xl">1. Use of the Service</h2>
            <p className="mb-2 sm:mb-3">
              You are granted a limited, non-exclusive, non-transferable, revocable license to use
              the Service for lawful purposes in accordance with these Terms.
            </p>
            <p className="mb-1.5 sm:mb-2">You agree not to:</p>
            <ul className="list-disc space-y-0.5 pl-5 sm:space-y-1 sm:pl-6">
              <li>Use the Service for unlawful, fraudulent, or unauthorized purposes</li>
              <li>Attempt to gain unauthorized access to systems, accounts, or data</li>
              <li>
                Reverse engineer, copy, modify, or distribute the Service except as expressly
                permitted by law
              </li>
              <li>Interfere with the operation, security, or availability of the Service</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-brand sm:mb-3 sm:text-xl">2. Accounts</h2>
            <p>
              Access to certain features requires an account. You are responsible for maintaining
              the confidentiality of your login credentials and for all activity under your account.
              You agree to provide accurate information and to notify us promptly of unauthorized
              account use.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-brand sm:mb-3 sm:text-xl">3. Subscriptions and Billing</h2>
            <p className="mb-2 sm:mb-3">
              The Service may offer both free and paid subscription tiers with different feature
              access levels.
            </p>
            <ul className="list-disc space-y-0.5 pl-5 sm:space-y-1 sm:pl-6">
              <li>
                Paid plans are billed through third-party payment processors during web checkout
              </li>
              <li>Subscriptions may renew automatically unless canceled before renewal</li>
              <li>You can manage or cancel your subscription through billing management</li>
              <li>
                Pricing, plan features, and billing terms may be updated from time to time in
                accordance with applicable law
              </li>
            </ul>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-brand sm:mb-3 sm:text-xl">4. Privacy</h2>
            <p className="mb-2 sm:mb-3">Use of the Service is also governed by our Privacy Policy.</p>
            <Link to="/privacy" className="font-semibold text-brand hover:text-orange-dark">
              Privacy Policy
            </Link>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-brand sm:mb-3 sm:text-xl">5. Intellectual Property</h2>
            <p>
              All content, trademarks, logos, software, and materials used in the Service are the
              property of
              Sweetest Interactive Entertainment LLC or its licensors and may not be used without
              authorization.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-brand sm:mb-3 sm:text-xl">6. Disclaimer of Warranties</h2>
            <p>
              The Service is provided "as is" and "as available," without warranties of any kind.
              We do not guarantee uninterrupted, secure, or error-free operation at all times.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-brand sm:mb-3 sm:text-xl">7. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, Sweetest Interactive shall
              not be liable for direct, incidental, or consequential damages arising from the use of
              or inability to use the Service.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-brand sm:mb-3 sm:text-xl">8. Termination</h2>
            <p>
              We reserve the right to suspend or terminate access to the Service at any time if
              these Terms are violated or if necessary to protect the Service, users, or business
              operations.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-brand sm:mb-3 sm:text-xl">9. Changes to These Terms</h2>
            <p>
              We may update these Terms from time to time. Any updates will be posted with a revised
              Effective Date. Continued use of the Service after changes become effective constitutes
              acceptance of the updated Terms.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-base font-semibold text-brand sm:mb-3 sm:text-xl">10. Contact Information</h2>
            <p className="font-semibold">
              Sweetest Interactive Entertainment LLC DBA Sweetest Interactive.
            </p>
            <p className="mt-2 sm:mt-3">
              Email:{" "}
              <a className="break-all font-semibold text-brand hover:text-orange-dark" href="mailto:itsyummtime@sweetestinteractive.com">
                itsyummtime@sweetestinteractive.com
              </a>
            </p>
            <p className="mt-2 sm:mt-3">Phoenix, AZ</p>
          </section>
        </div>
      </div>
    </div>
  )
}
